// src/pages/system/User.jsx
import React from "react";
import useUserProfile from "../../hooks/useUserprofile";

// Components
import AccountForm from "../../components/common/profile/AccountForm";
import OrgInfo from "../../components/common/profile/OrgInfo";
import PasswordChange from "../../components/common/profile/PasswordChange";
import SignatureSection from "../../components/common/profile/SignatureSection";

export default function User() {
  const {
    loading,
    error,
    form,
    onChange,
    onChangePhone,
    onChangePw,
    org,
    showPasswordFields,
    setShowPasswordFields,
    passwordVerified,
    verifyCurrentPassword,
    passwords,
    submitPasswordChange,
    signaturePreview,
    setSignaturePreview,
    setSignatureFile,
    profileImagePreview,
    setProfileImagePreview,
    setProfileImageFile,
    isMyProfile,
    handleSubmit,
  } = useUserProfile();

  if (loading) {
    return (
      <div className="p-8 flex justify-center items-center">
        <div className="animate-pulse text-gray-500 text-lg">로딩중...</div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      {/* ⭐ Profile Header Area */}
      <div className="flex items-center gap-6 bg-white p-6 rounded-2xl border shadow-sm">
        {/* Profile Image */}
        <div className="relative">
          <div className="w-28 h-28 rounded-full overflow-hidden border flex items-center justify-center bg-gray-100">
            {profileImagePreview ? (
              <img
                src={profileImagePreview}
                alt="profile"
                className="object-cover w-full h-full"
              />
            ) : (
              <span className="text-gray-400 text-sm">이미지 없음</span>
            )}
          </div>

          <input
            type="file"
            accept="image/*"
            id="profileUpload"
            className="hidden"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setProfileImageFile(file);
                setProfileImagePreview(URL.createObjectURL(file));
              }
            }}
          />

          <label
            htmlFor="profileUpload"
            className="absolute bottom-0 right-0 bg-blue-600 text-white text-xs px-2 py-1 rounded cursor-pointer hover:bg-blue-700"
          >
            변경
          </label>
        </div>

        {/* Profile Summary */}
        <div>
          <h2 className="text-2xl font-semibold">
            {form.last_name}
            {form.first_name}
          </h2>
          <p className="text-gray-600 mt-1">{form.email}</p>

          <div className="flex gap-4 mt-2 text-sm text-gray-500">
            <span>{org.company_name}</span>
            <span>{org.department_name}</span>
            <span>{org.position_name}</span>
          </div>
        </div>
      </div>

      {/* ⭐ MAIN FORM */}
      <form
        onSubmit={handleSubmit}
        className="rounded-2xl border bg-white shadow-sm overflow-hidden"
      >
        <AccountForm
          form={form}
          onChange={onChange}
          onChangePhone={onChangePhone}
        />
        <OrgInfo org={org} />

        <PasswordChange
          isMyProfile={isMyProfile}
          showPasswordFields={showPasswordFields}
          setShowPasswordFields={setShowPasswordFields}
          passwordVerified={passwordVerified}
          verifyCurrentPassword={verifyCurrentPassword}
          passwords={passwords}
          onChangePw={onChangePw}
          submitPasswordChange={submitPasswordChange}
        />

        <SignatureSection
          isMyProfile={isMyProfile}
          signaturePreview={signaturePreview}
          setSignaturePreview={setSignaturePreview}
          setSignatureFile={setSignatureFile}
        />

        {error && (
          <div className="mx-6 mb-4 rounded-md border border-red-300 bg-red-50 px-4 py-2 text-sm text-red-600">
            {error}
          </div>
        )}

        <div className="border-t bg-gray-50 px-6 py-4 flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
          >
            저장
          </button>
        </div>
      </form>
    </div>
  );
}
